import AboutPageTemplate, { AboutPageTemplateProps } from './template';
import { useRouter } from 'next/router';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { additionalLinkTags, SEO } from '../../../utils/SEO';

/**
 * AboutPage
 */
const AboutPage: React.FC<AboutPageTemplateProps> = (props) => {
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000/';
  const router = useRouter();

  const isEn = router.locale === 'en';

  const itemListElements = [
    {
      position: 1,
      name: 'App Masters',
      item: `${siteUrl}${router.locale}`,
    },
    {
      position: 2,
      name:
        props.metaTitle ||
        ((isEn ? 'About us | App Masters' : 'Sobre nós | App Masters') as string),
      item: `${siteUrl}${router.locale}/${isEn ? 'about' : 'sobre'}`,
    },
  ];

  return (
    <>
      <NextSeo
        {...SEO({
          pathname: router.asPath,
          locale: router.locale as string,
          title: (props.metaTitle || props.title) as string,
          defaultTitle: {
            enTitle: 'About us',
            ptTitle: 'Sobre nós',
          },
          description: (props.metaDescription || props.description) as string,
          image: (props.metaImage || props.bannerUrl) as string,
          hideAppMastersTitle: props.hideAppMastersTitle as boolean,
        })}
        additionalLinkTags={additionalLinkTags(['sobre', 'about'])}
      />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      <AboutPageTemplate {...props} aboutDynamic={props.aboutDynamic} />
    </>
  );
};

export default AboutPage;
